var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c(_vm.monthOfYear, {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: _vm.isMobile ? 10 : 4,
      expression: "isMobile ? 10 : 4"
    }],
    tag: "component",
    attrs: {
      "month": _vm.month,
      "is-disabled-prev": _vm.isDisabledPrevMonth,
      "is-disabled-next": _vm.isDisabledNextMonth
    },
    on: {
      "prev-month": function prevMonth($event) {
        return _vm.$emit('prev-month');
      },
      "next-month": function nextMonth($event) {
        return _vm.$emit('next-month');
      }
    }
  }), _c('days-of-week'), _c('div', {
    class: _vm.$style.daysContainer
  }, _vm._l(_vm.days, function (dayIndex, index) {
    return _c('div', {
      key: index,
      class: [_vm.$style.dayBlock, _vm.isDisabled(dayIndex) && _vm.$style.disabled, _vm.isLeft(dayIndex) && _vm.$style.leftBorder, _vm.isRight(dayIndex) && _vm.$style.rightBorder],
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.onMouseHoverDay(dayIndex);
        }
      }
    }, [_vm.isCurrentMonth(dayIndex) ? _c('div', {
      class: [_vm.$style.day, _vm.isDarkHighlight(dayIndex) && _vm.$style.darkHighlight, _vm.isHighlighted(dayIndex) && _vm.$style.highlight],
      on: {
        "click": function click($event) {
          return _vm.onClickDay(dayIndex);
        }
      }
    }, [_vm._v(" " + _vm._s(dayIndex + 1) + " ")]) : _vm._e()]);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }